export default {
	namespaced: true,
	state: () => ({
		rpcUrl:"https://swift-mariele-fast-mainnet.helius-rpc.com/",
	}),
	mutations: {
		//
	}
}
